import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AppTemplate from '@/app/shared/ui/templates/AppTemplate.vue';
import ClientRepository from '@/app/client/infrastructure/persistence/ClientRepository';
import Table from '@/app/shared/components/Table.vue';
import { inject, onMounted, ref } from 'vue';
import useNotificationRepository from '@/app/shared/infrastructure/persistence/notification-repository';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientList',
  setup(__props) {

const notificationRepository = useNotificationRepository();
const repository = inject('clientRepository') as ClientRepository;
const items = ref<any[]>([]);

async function loadData() {
    items.value = await repository.getAll();
}

onMounted(loadData);

const columns = [
    {title: 'ID', key: 'id'},
    {title: 'Nome', key: 'name'},
    {title: 'E-mail', key: 'email'},
];

const deleteClient = async (client: any) => {
    if (confirm('Deseja excluir o cliente ' + client.id)) {
        await repository.remove(client.id);

        notificationRepository.insert({
            id: Date.now().toString(),
            type: 'success',
            message: 'Cliente removido com sucesso',
        });

        loadData();
    }
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(AppTemplate, null, {
    default: _withCtx(() => [
      _createVNode(Table, {
        items: items.value,
        title: "Clientes",
        "key-filter": "name",
        columns: columns
      }, {
        "append-title": _withCtx(() => [
          _createVNode(_component_v_btn, {
            to: "/clientes/cadastrar",
            "prepend-icon": "mdi:mdi-content-save",
            color: "primary",
            variant: "flat"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cadastrar")
            ]),
            _: 1
          })
        ]),
        "edit-button": _withCtx(({ item }) => [
          _createVNode(_component_v_btn, {
            to: `/clientes/editar/${item.id}`,
            icon: "",
            size: "x-small",
            class: "mr-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [
                  _createTextVNode("mdi:mdi-pencil")
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        "remove-button": _withCtx(({ item }) => [
          _createVNode(_component_v_btn, {
            onClick: ($event: any) => (deleteClient(item)),
            icon: "",
            size: "x-small"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [
                  _createTextVNode("mdi:mdi-delete")
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["items"])
    ]),
    _: 1
  }))
}
}

})